module.exports = __webpack_public_path__ + "img/43.0fbc73c6.svg";